'use client';

import { Button, Menu, MenuItem } from '@mui/material';
import { FC, useState } from 'react';

interface RegionSelectorProperties {
  selectedRegion: string;
  regions: { key: string; label: string }[];
}

export const RegionSelector: FC<RegionSelectorProperties> = ({
  selectedRegion,
  regions,
}) => {
  // TODO: should include region auto-detection business logic
  // (find closes region, handle use case when user rejected location detection, etc.)
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const open = Boolean(anchor);
  const [region, setRegion] = useState(selectedRegion);
  const regionLabel = regions.find((l) => l.key === region)!.label;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchor(event.currentTarget);
  };

  const handleClose = () => {
    setAnchor(null);
  };

  const updateRegion = (regionKey: string) => {
    setRegion(regionKey);
    handleClose();
  };

  return (
    <>
      <Button variant="text" onClick={handleClick}>
        {regionLabel}
      </Button>
      <Menu open={open} anchorEl={anchor} onClose={handleClose}>
        {regions.map(({ key, label }) => (
          <MenuItem key={key} onClick={() => updateRegion(key)}>
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
